import { useTranslation } from 'react-i18next';
import { Flex, Typography } from 'antd';
import { useTripTaskStore } from 'shared/stores';
import { ELocationMode } from 'components/trips/trip-create-task-modal/types';
import { CoordinatesForm } from '../coordinates-form';
import { LocationSwitcher } from '../location-switcher';
import { SharedAddressFields } from '../shared-address-fields';
import { WarehouseSelector } from '../warehouse-selector';

export const ReloadingFromTaskForm = () => {
  const { t } = useTranslation('trip');

  const {
    locationMode,
    coordinates,
    address,
    warehouseId,
    setWarehouseId,
    setLocationMode,
    setCoordinates,
    setAddress,
  } = useTripTaskStore();

  return (
    <Flex gap='large' vertical>
      <Typography.Text type='secondary'>{t('reloading_from_location')}</Typography.Text>
      <LocationSwitcher value={locationMode} onChange={setLocationMode} />
      {locationMode === ELocationMode.coordinates ? (
        <CoordinatesForm value={coordinates} onChange={setCoordinates} />
      ) : (
        <SharedAddressFields value={address} onChange={setAddress} />
      )}

      <Typography.Text type='secondary'>{t('reloading_from_warehouse')}</Typography.Text>
      <WarehouseSelector value={warehouseId} onChange={setWarehouseId} />
    </Flex>
  );
};
